import { useCallback, useEffect, useRef, useState } from "react";
import Product from "./Product";

const RelatedProductsCarousel = ({ products = [], title }) => {
  const scrollerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const showArrows = products.length > 4;

  const updateScrollControls = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    setCanScrollLeft(scroller.scrollLeft > 2);
    setCanScrollRight(scroller.scrollLeft < maxScrollLeft - 2);
  }, []);

  useEffect(() => {
    updateScrollControls();
    window.addEventListener("resize", updateScrollControls);
    return () => window.removeEventListener("resize", updateScrollControls);
  }, [products, updateScrollControls]);

  const scrollRelatedProducts = (direction) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollBy({
      left: direction * scroller.clientWidth,
      behavior: "smooth",
    });
  };

  if (!products.length) return null;

  return (
    <section className="mt-5" aria-labelledby="related-products-heading">
      <div className="d-flex align-items-center justify-content-between gap-3 mb-2">
        <h2 id="related-products-heading" className="mb-0">{title}</h2>
        {showArrows && (
          <div className="related-products-controls d-flex gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary related-products-arrow"
              aria-label="Previous related products"
              onClick={() => scrollRelatedProducts(-1)}
              disabled={!canScrollLeft}
            >
              <span aria-hidden="true">‹</span>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary related-products-arrow"
              aria-label="Next related products"
              onClick={() => scrollRelatedProducts(1)}
              disabled={!canScrollRight}
            >
              <span aria-hidden="true">›</span>
            </button>
          </div>
        )}
      </div>

      <div
        ref={scrollerRef}
        className="related-products-scroller"
        onScroll={updateScrollControls}
      >
        {products.map((product) => (
          <div className="related-products-item" key={product._id}>
            <Product product={product} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default RelatedProductsCarousel;
